import {
    deliverySchema,
    nonDeliverySchema,
} from '@/features/pos/components/CustomerProfile/form/schema'
import {
    FormContext,
    FormInput,
    FormOutput,
} from '@/features/pos/components/CustomerProfile/form/types'
import { zodResolver } from '@hookform/resolvers/zod'
import { ResolverOptions } from 'react-hook-form'
import invariant from 'tiny-invariant'
import { ZodType } from 'zod/v4'

const getSchema = (context: FormContext): ZodType<FormOutput, FormInput> => {
    return context.isDelivery ? deliverySchema : nonDeliverySchema
}

export const dynamicResolver = (
    values: FormInput,
    context: FormContext | undefined,
    options: ResolverOptions<FormInput>
) => {
    invariant(context, 'Form context is not defined')

    const schema = getSchema(context)

    return zodResolver(schema)(values, context, options)
}
